import React from "react";
import { FiUser } from "react-icons/fi";
import InfoCard from "./InfoCard";
import { BiFoodMenu } from "react-icons/bi";
import { MdLocalOffer, MdTrendingUp } from "react-icons/md";
import { MdOutlineLocalOffer } from "react-icons/md";
import { useState, useEffect } from "react";
import { useAppContext } from "../../Context/AppContext.jsx";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const MainDashboard = () => {
  const { logout } = useAppContext();
  const { token } = useAppContext();
  const [productsLength, setProductsLength] = useState(0);
  const [specialesLength, setSpecialesLength] = useState(0);
  const [usersLength, setUsersLength] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const getSize = async ({ request }) => {
      try {
        const response = await fetch(request.url, {
          method: request.method,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();

          if (data.success) {
            if (typeof data.data === "number") {
              return data.data;
            } else {
              return data.data[0].length;
            }
          }
        } else {
          throw new Error(response.status);
        }
      } catch (err) {
        if (err.message === "401") {
          toast.error("Inicie sesion para poder acceder al dashboard.");
          setTimeout(() => {
            logout();
            navigate("/login");
          }, 2000);
        }
      }
      return 0;
    };

    const loadData = async () => {
      try {
        setProductsLength(
          await getSize({
            request: {
              url: process.env.REACT_APP_URL +  "api/menu",
              method: "GET",
              headers: { Authorization: `Bearer ${token}` },
            },
          }),
        );
        setSpecialesLength(
          await getSize({
            request: {
              url: process.env.REACT_APP_URL +  "api/menu?name=mariposa",
              method: "GET",
            },
          }),
        );
        setUsersLength(
          await getSize({
            request: {
              url: process.env.REACT_APP_URL +  "api/users/length",
              method: "GET",
            },
          }),
        );
      } catch (err) {}
    };

    loadData();
  }, [token]);

  return (
    <div className="bg-white flex flex-col w-full">
      <div className="flex px-4 py-10 w-full gap-10 flex-wrap justify-evenly">
        <InfoCard title="Usuarios" description={usersLength} icon={FiUser} />
        <InfoCard
          title="Productos"
          description={productsLength}
          icon={BiFoodMenu}
        />
        <InfoCard
          title="Especiales"
          description={specialesLength}
          icon={MdLocalOffer}
        />
      </div>
    </div>
  );
};
export default MainDashboard;
